import { isEmpty } from 'lodash';
import { SelectOption } from '~/definitions/admin';
import { getStore } from '~/mobx/AppStore';

export const getSelectOptionsFromAttribute = (number: string): SelectOption[] => {
    const { adminStore } = getStore();
    const electionAttributes = adminStore.election?.attributes || [];
    const electionModel = electionAttributes?.find((attr) => attr?.number === number);
    if (isEmpty(electionModel) || !electionModel.options) {
        return [];
    }

    return electionModel.options.map((option) => ({
        label: option?.value || '',
        value: option?.valueId || '',
    }));
};
